import {ref, Ref, watch, computed, unref} from 'vue';

export function usePrefetchImages(urls: Ref<(string | undefined)[]> | (string | undefined)[]) {
    const loaded = ref(false);

    const computedUrls = computed(() => unref(urls));

    async function prefetchLanguageImages(value: (string | undefined)[]) {
        loaded.value = false;
        await Promise.all(
            value
                .filter((f): f is string => !!f)
                .map((url) => {
                    return new Promise((res) => {
                        const img = new Image();
                        img.onload = res;
                        img.src = url;
                    });
                }),
        );
        loaded.value = true;
    }

    watch(computedUrls, prefetchLanguageImages, {deep: true, immediate: true});

    return {
        loaded,
    };
}
